<template>
    <div class="user-center">
        <div class="navs-mask">
            <div class="main-body">
                <div class="base-info-mask"
                     @click="$router.push({
                         name: 'userInfo'
                     })"
                >
                    <img :src="userInfo.app_poster || avatarDefault" class="avatar">
                    <div class="infos">
                        <p class="name">
                            {{ userInfo.user_name }}
                        </p>
                        <p class="email">
                            {{ userInfo.email }}
                        </p>
                    </div>
                    <img class="more-icon" src="@/assets/img/more-gray.png">
                </div>
                <div v-for="(item,index) in navs"
                     :key="index"
                     class="nav-item"
                     @click="navItemClick(item,index)"
                >
                    <img class="nav-icon" :src="item.icon">
                    <p :style="{color:index === checkedNavIndex?'#303133': ''}">
                        {{ langTransfer(item.text) }}
                    </p>
                    <img class="more-icon" src="@/assets/img/more-gray.png">
                </div>
            </div>
            <div class="action-wrap">
                <button class="change-pwd"
                        @click="$router.push({
                            name: 'changePassword'
                        })"
                >
                    修改密码
                </button>
                <button class="login-out"
                        @click="loginOut"
                >
                    退出登录
                </button>
            </div>
        </div>
        <div class="router-view-mask">
            <router-view />
        </div>
    </div>
</template>

<script>
    import { userInfo } from '@/api/hb'

    const avatarDefault = require('@/assets/avatar-default.png')
    const subscribeIcon = require('@/assets/img/user-center/subscribe.png')
    const collectionIcon = require('@/assets/img/user-center/collection.png')
    const markIcon = require('@/assets/img/user-center/mark.png')

    export default {
        name: 'UserCenter',
        components: {},
        data () {
            return {
                checkedNavIndex: 0,
                navs: [
                    {
                        icon: subscribeIcon,
                        text: '我的订阅',
                        routeName: 'userFocus'
                    },
                    {
                        icon: collectionIcon,
                        text: '我的收藏',
                        routeName: 'userCollection'
                    },
                    {
                        icon: markIcon,
                        text: '我的书签',
                        routeName: 'userMark'
                    }
                ],
                userInfos: {},
                avatarDefault
            }
        },
        computed: {
            pageSetup () {
                return this.$store.state.pageSetup
            },
            webInfo () {
                return this.$store.state.webInfo
            },
            user_unique_code () {
                return this.$store.state.user_unique_code
            },
            userInfo () {
                return this.$store.state.userInfo
            }
        },
        mounted () {
            this.getUserInfo()
            this.initCheckedIndex()
        },
        methods: {
            async getUserInfo () {
                try {
                    const data = await userInfo({
                        service_code: this.webInfo.service_code,
                        user_unique_code: this.user_unique_code
                    })
                    this.$store.commit('setUserInfo', data)
                } catch (err) {
                    console.log(err)
                }
            },
            navItemClick (item, index) {
                if (this.checkedNavIndex === index) {
                    return
                }
                this.checkedNavIndex = index
                this.$router.push({
                    name: item.routeName
                })
            },
            initCheckedIndex () {
                this.checkedNavIndex = this.navs.findIndex((e) => {
                    return e.routeName === this.$route.name
                })
            },
            loginOut () {
                this.$cookies.remove('user_unique_code')
                this.$router.go(0)
            }
        },
        beforeRouteEnter (to, from, next) {
            next((vm) => {
                if (!vm.user_unique_code) {
                    vm.$router.replace({
                        name: 'home'
                    })
                }
            })
        }
    }
</script>

<style scoped lang="less">
    .user-center {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;
    }

    .navs-mask {
        width: 300px;
        height: 100%;
        background: #FFFFFF;
        box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        position: relative;
        z-index: 1;
    }

    .main-body {
        width: 300px;
        min-height: 270px;
    }

    .base-info-mask {
        width: 100%;
        height: 108px;
        box-sizing: border-box;
        padding: 30px 20px 30px 30px;
        background: #F5F7FA;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        .avatar {
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin-right: 10px;
        }

        .infos {
            flex: 1;

            .name {
                font-size: 18px;
                font-family: AlibabaPuHuiTiB;
                color: #303133;
                line-height: 18px;
            }

            .email {
                margin-top: 4px;
                font-size: 13px;
                font-family: AlibabaPuHuiTiR;
                color: #909399;
                line-height: 20px;
            }
        }
    }

    .more-icon {
        width: 24px;
        height: 24px;
    }

    .nav-item {
        width: 100%;
        height: 54px;
        box-shadow: 0px 1px 0px 0px #E6E6E6;
        box-sizing: border-box;
        padding: 15px 20px 15px 30px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;

        .nav-icon {
            width: 24px;
            height: 24px;
        }

        p {
            flex: 1;
            font-size: 15px;
            font-family: AlibabaPuHuiTiM;
            color: #606266;
            line-height: 24px;
        }
    }

    .action-wrap {
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        padding: 0 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .change-pwd {
            height: 20px;
            font-size: 12px;
            font-family: AlibabaPuHuiTiM;
            color: #606266;
        }

        .login-out {
            width: 72px;
            height: 28px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #303133;
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
        }
    }

    .router-view-mask {
        flex: 1;
        height: 100%;
        overflow: hidden;
    }
</style>

<style lang="less">
    .user-common-view {
        width: 100%;
        box-sizing: border-box;
        padding: 0 48px 40px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    .action-block {
        width: 640px;
        background: #FFFFFF;
        border-radius: 8px;
        border: 1px solid #CCCCCC;
        overflow: hidden;
        margin-top: 30px;

        .action-header {
            width: 100%;
            box-sizing: border-box;
            padding: 10px 20px;
            font-size: 13px;
            font-family: AlibabaPuHuiTiM;
            color: #909399;
            line-height: 20px;
            background: #F5F7FA;
        }
    }

    .active-item {
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        padding: 20px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;

        h5 {
            width: 58px;
            margin-right: 60px;
            font-size: 13px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
            line-height: 20px;
        }

        input {
            width: 316px;
            height: 40px;
            box-sizing: border-box;
            padding: 8px;
            background: #FFFFFF;
            border-radius: 6px;
            border: 1px solid #CCCCCC;
            font-size: 13px;
            font-family: AlibabaPuHuiTiR;
            color: #303133;
        }
    }

    .change-avatar {
        box-shadow: 0px 1px 0px 0px #E6E6E6;

        .user-avatar {
            width: 40px;
            height: 40px;
            border-radius: 40px;
        }

        p {
            width: 202px;
            margin: 0 220px 0 78px;
            font-size: 13px;
            font-family: AlibabaPuHuiTiR;
            color: #909399;
            line-height: 20px;
        }

        .upload-avatar {
            width: 60px;
            height: 36px;
            background: #FFFFFF;
            border-radius: 18px;
            font-size: 14px;
            font-family: AlibabaPuHuiTiM;
            color: #303133;
        }
    }

    .change-name {

        button {
            width: 60px;
            height: 36px;
            font-size: 14px;
            font-family: AlibabaPuHuiTiM;
            color: #FFFFFF;
            background: #303133;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 18px;
            margin-left: 106px;
        }
    }

    .send-code {

        button {
            width: 101px;
            height: 36px;
            font-size: 14px;
            font-family: AlibabaPuHuiTiM;
            color: #FFFFFF;
            background: #303133;
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
            border-radius: 18px;
            margin-left: 65px;
        }
    }

    .main-btn {
        display: block;
        margin: 0 auto 20px;
        width: 108px;
        height: 48px;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #FFFFFF;
        background: #303133;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
        border-radius: 8px;
    }
</style>

<style>
    .info-view input::-webkit-input-placeholder {
        /* WebKit browsers */
        color: #909399;
    }
    .info-view input:-moz-placeholder {
        /* Mozilla Firefox 4 to 18 */
        color: #909399;
    }
    .info-view input::-moz-placeholder {
        /* Mozilla Firefox 19+ */
        color: #909399;
    }
    .info-view input::-ms-input-placeholder {
        /* Internet Explorer 10+ */
        color: #909399;
    }
</style>
